module.exports = __webpack_public_path__ + "static/julie-zhuo-3cd90c47d03c133ffa2bc3fb862cf9d5.jpg";